import React from 'react';

export type INoPageProps = {

}

const NoPage: React.FC<INoPageProps> = ({ }) => {
  return (
    <div>
      <h3>URL not found</h3>
    </div>
  );
};

export { NoPage };
